// BOT-484: "Check vendor before quoting" — one line, coloured by the strongest part
// (red > amber > gray, decided by the API). decision: freshness — see decisions/freshness.md
import type { AlertColor, FreshnessAlertPart, ItemFreshness } from '../../api/products';

const NAME: Record<FreshnessAlertPart['value'], string> = { price: 'Price', home_value: 'Home Value' };

const TONE: Record<AlertColor, string> = {
  amber: 'border-amber-200 bg-amber-50 text-amber-800',
  red:   'border-red-200 bg-red-50 text-red-700',
  gray:  'border-gray-200 bg-gray-100 text-gray-700',
};

export function alertPartText(p: FreshnessAlertPart): string {
  const name = NAME[p.value];
  if (p.reason === 'in_review') return `${name} differs — in Review`;
  const age = p.days_ago == null ? 'outdated' : `${p.days_ago} days old`;   // null = contract break
  const base = p.reason === 'never' ? `${name} never confirmed` : `${name} is ${age}`;
  return p.pending_review ? `${base} · in Review` : base;
}

export default function FreshnessAlert({ alert }: { alert: ItemFreshness['alert'] | undefined }) {
  if (!alert || alert.parts.length === 0) return null;
  return (
    <div
      role="status"
      data-testid="freshness-alert"
      data-color={alert.color}
      className={`rounded-lg border px-4 py-2 text-sm font-medium ${TONE[alert.color]}`}
    >
      {['Check vendor before quoting', ...alert.parts.map(alertPartText)].join(' · ')}
    </div>
  );
}
